export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const waitFor = async (predicate: () => boolean) => {
  while (!predicate()) {
    // eslint-disable-next-line no-await-in-loop
    await delay(10);
  }
};
